// extracted by mini-css-extract-plugin
module.exports = {"page":"Visit_page__20Dmx","button":"Visit_button__SuZLx","meetings":"Visit_meetings__188UB","title":"Visit_title__1TtFb","notify":"Visit_notify__1UwvN"};